export const getType = (types, typeId) => types.find((type) => type.id === typeId)

export const getProvider = (providers, providerId) => {
  if (providers?.length) {
    return providers.find((provider) => provider.id === providerId);
  }
  return null;
}
